import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=1636ab61&scoped=true"
import script from "./Question.vue?vue&type=script&lang=js"
export * from "./Question.vue?vue&type=script&lang=js"
import style0 from "./Question.vue?vue&type=style&index=0&id=1636ab61&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1636ab61",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1636ab61')) {
      api.createRecord('1636ab61', component.options)
    } else {
      api.reload('1636ab61', component.options)
    }
    module.hot.accept("./Question.vue?vue&type=template&id=1636ab61&scoped=true", function () {
      api.rerender('1636ab61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/qna/Question.vue"
export default component.exports